import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "./../../components/successMessage";
import FailedMessage from "./../../components/FailedMessage";

const AddHtmlDoc = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    active: true,
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      setMessage("Failed: Missing authentication token.");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/HtmlDocOperation/SubUser/Insert",
        {
          ...formData,
          active: formData.active === "true" || formData.active === true,
        },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // Success from API
      if (response.data?.isresponse && response.data?.responsestatus === "SUCCESS") {
        setMessage("HTML Document added successfully!");

        setTimeout(() => navigate("/htmldoclist"), 2500);
        return;
      }

      // API returned fail (like: already exist)
      setMessage(response.data?.errormsg || "Failed to add HTML document.");

    } catch (error) {
      // Error from server
      setMessage(
        error.response?.data?.errormsg ||
        error.message ||
        "Failed to add HTML document."
      );
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <h1>Add HTML Document</h1>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="card card-info">
                <div className="card-header">
                  <h3 className="card-title">Add HTML Document</h3>
                </div>

                <div className="card-body">
                  <form id="add-items" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter name..."
                          required
                        />
                      </div>

                      <div className="col-sm-6">
                        <label>HTML Document Description</label>
                        <input
                          type="text"
                          className="form-control"
                          name="remark"
                          value={formData.remark}
                          onChange={handleChange}
                          placeholder="Enter description..."
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <label>Active</label>
                        <select
                          className="form-control"
                          name="active"
                          value={formData.active}
                          onChange={handleChange}
                        >
                          <option value={true}>Active</option>
                          <option value={false}>Deactive</option>
                        </select>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-info mt-3">
                      Add
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Success / Fail Messages */}
      {message === "HTML Document added successfully!" && (
        <SuccessMessage message={message} />
      )}

      {message !== "" && message !== "HTML Document added successfully!" && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

export default AddHtmlDoc;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
